export default [
    {
        countryName: 'AFGHANISTAN',
        countryCode: 'AF',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'AFRIQUE DU SUD',
        countryCode: 'ZA',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ALBANIE',
        countryCode: 'AL',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'ALGERIE',
        countryCode: 'DZ',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'ALLEMAGNE',
        countryCode: 'DE',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'ANGOLA',
        countryCode: 'AO',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ANGUILLA',
        countryCode: 'AI',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ANTIGUA-ET-BARBUDA',
        countryCode: 'AG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ANTILLES NEERLANDAISES',
        countryCode: 'AN',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ARABIE SAOUDITE',
        countryCode: 'SA',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ARGENTINE',
        countryCode: 'AR',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ARMENIE',
        countryCode: 'AM',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'ARUBA',
        countryCode: 'AW',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ASCENSION',
        countryCode: 'AC',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'AUSTRALIE',
        countryCode: 'AU',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'AUTRICHE',
        countryCode: 'AT',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'AZERBAIJAN',
        countryCode: 'AZ',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'BAHAMAS',
        countryCode: 'BS',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BAHREIN',
        countryCode: 'BH',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BANGLADESH',
        countryCode: 'BD',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BARBADE',
        countryCode: 'BB',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BELGIQUE',
        countryCode: 'BE',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'BELIZE',
        countryCode: 'BZ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BENIN',
        countryCode: 'BJ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BERMUDES',
        countryCode: 'BM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BHOUTAN',
        countryCode: 'BT',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BIELORUSSIE',
        countryCode: 'BY',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'BIRMANIE',
        countryCode: 'MM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BOLIVIE',
        countryCode: 'BO',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BONAIRE, SAINT-EUSTACHE ET SABA',
        countryCode: 'BQ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Bosnie Herzégovine',
        countryCode: 'BA',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'BOTSWANA',
        countryCode: 'BW',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Brésil',
        countryCode: 'BR',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BRUNEI DARUSSALAM',
        countryCode: 'BN',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BULGARIE',
        countryCode: 'BG',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'BURKINA FASO',
        countryCode: 'BF',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'BURUNDI',
        countryCode: 'BI',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'CAMBODGE',
        countryCode: 'KH',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'CAMEROUN',
        countryCode: 'CM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'CANADA',
        countryCode: 'CA',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'CAP-VERT',
        countryCode: 'CV',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'CHILI',
        countryCode: 'CL',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'CHINE',
        countryCode: 'CN',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'CHYPRE',
        countryCode: 'CY',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'COLOMBIE',
        countryCode: 'CO',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'COMORES',
        countryCode: 'KM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'CONGO',
        countryCode: 'CG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Corée du Sud ',
        countryCode: 'KR',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'Corée du Nord',
        countryCode: 'KP',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'COSTA RICA',
        countryCode: 'CR',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Côte d\'Ivoire',
        countryCode: 'CI',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'CROATIE',
        countryCode: 'HR',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'CUBA',
        countryCode: 'CU',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'CURACAO',
        countryCode: 'CW',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'DANEMARK',
        countryCode: 'DK',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'DJIBOUTI',
        countryCode: 'DJ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'DOMINIQUE',
        countryCode: 'DM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'EGYPTE',
        countryCode: 'EG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'EMIRATS ARABES UNIS',
        countryCode: 'AE',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'EQUATEUR',
        countryCode: 'EC',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Erythrée',
        countryCode: 'ER',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ESPAGNE',
        countryCode: 'ES',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'ESTONIE',
        countryCode: 'EE',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'ETATS-UNIS',
        countryCode: 'US',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'ETHIOPIE',
        countryCode: 'ET',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'FIDJI',
        countryCode: 'FJ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'FINLANDE',
        countryCode: 'FI',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'FRANCE',
        countryCode: 'FR',
        deliveryTime: 2,
        shippingFee: 0,
    },
    {
        countryName: 'GABON',
        countryCode: 'GA',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'GAMBIE',
        countryCode: 'GM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Géorgie ',
        countryCode: 'GE',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'Géorgie du Sud et les Iles Sandwich du Sud ',
        countryCode: 'GS',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'GHANA',
        countryCode: 'GH',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'GIBRALTAR',
        countryCode: 'GI',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'Grèce ',
        countryCode: 'GR',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'GRENADE',
        countryCode: 'GD',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'GROENLAND',
        countryCode: 'GL',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'GUAM',
        countryCode: 'GU',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'GUATEMALA',
        countryCode: 'GT',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'GUERNESEY',
        countryCode: 'GG',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'Guinée ',
        countryCode: 'GN',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Guinée Equatoriale',
        countryCode: 'GQ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Guinée-Bissau ',
        countryCode: 'GW',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'GUYANA',
        countryCode: 'GY',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'HAITI',
        countryCode: 'HT',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'HONDURAS',
        countryCode: 'HN',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'HONG KONG',
        countryCode: 'HK',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'HONGRIE',
        countryCode: 'HU',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'ILE BOUVET',
        countryCode: 'BV',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Ile de Man ',
        countryCode: 'IM',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'ILE NORFOLK',
        countryCode: 'NF',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES ALAND',
        countryCode: 'AX',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES CAIMANES',
        countryCode: 'KY',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES CANARIES',
        countryCode: 'IC',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'ILES CHRISTMAS',
        countryCode: 'CX',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES COCOS (KEELING)',
        countryCode: 'CC',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES COOK',
        countryCode: 'CK',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Iles Féroé',
        countryCode: 'FO',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'ILES HEARD ET MC DONALD',
        countryCode: 'HM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES MALOUINES (FALKLAND)',
        countryCode: 'FK',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES MARIANNES DU NORD',
        countryCode: 'MP',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES MARSHALL',
        countryCode: 'MH',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES SALOMON',
        countryCode: 'SB',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES TURQUES ET CAIQUES',
        countryCode: 'TC',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ILES VIERGES BRITANNIQUES',
        countryCode: 'VG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Iles Vierges des Etats-Unis ',
        countryCode: 'VI',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'INDE',
        countryCode: 'IN',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'INDONESIE',
        countryCode: 'ID',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'IRAN',
        countryCode: 'IR',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'IRAQ',
        countryCode: 'IQ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'IRLANDE',
        countryCode: 'IE',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'ISLANDE',
        countryCode: 'IS',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'Israël',
        countryCode: 'IL',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'ITALIE',
        countryCode: 'IT',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'JAMAIQUE',
        countryCode: 'JM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'JAPON',
        countryCode: 'JP',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'JERSEY',
        countryCode: 'JE',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'JORDANIE',
        countryCode: 'JO',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'KAZAKHSTAN',
        countryCode: 'KZ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'KENYA',
        countryCode: 'KE',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'KIRGHIZISTAN',
        countryCode: 'KG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'KIRIBATI',
        countryCode: 'KI',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'KOSOVO',
        countryCode: 'XZ',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'KOWEIT',
        countryCode: 'KW',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'LAO',
        countryCode: 'LA',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'LAOS',
        countryCode: 'PW',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'LESOTHO',
        countryCode: 'LS',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'LETTONIE',
        countryCode: 'LV',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'LIBAN',
        countryCode: 'LB',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Libéria',
        countryCode: 'LR',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'LIBYE',
        countryCode: 'LY',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'LIECHTENSTEIN',
        countryCode: 'LI',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'LITUANIE',
        countryCode: 'LT',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'LUXEMBOURG',
        countryCode: 'LU',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'MACAU',
        countryCode: 'MO',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Macédoine ',
        countryCode: 'MK',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'MADAGASCAR',
        countryCode: 'MG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'MALAISIE',
        countryCode: 'MY',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'MALAWI',
        countryCode: 'MW',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'MALDIVES',
        countryCode: 'MV',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'MALI',
        countryCode: 'ML',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'MALTE',
        countryCode: 'MT',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'MAROC',
        countryCode: 'MA',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'MAURICE',
        countryCode: 'MU',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'MAURITANIE',
        countryCode: 'MR',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'MEXIQUE',
        countryCode: 'MX',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Micronésie ',
        countryCode: 'FM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'MOLDAVIE',
        countryCode: 'MD',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'MONGOLIE',
        countryCode: 'MN',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Monténégro',
        countryCode: 'ME',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'MONTSERRAT',
        countryCode: 'MS',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'MOZAMBIQUE',
        countryCode: 'MZ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'NAMIBIE',
        countryCode: 'NA',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'NAURU',
        countryCode: 'NR',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Népal',
        countryCode: 'NP',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'NICARAGUA',
        countryCode: 'NI',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Nigéria',
        countryCode: 'NG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'NIUE',
        countryCode: 'NU',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Norvège ',
        countryCode: 'NO',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'Nouvelle-Zélande ',
        countryCode: 'NZ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'OMAN',
        countryCode: 'OM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'OUGANDA',
        countryCode: 'UG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Ouzbékistan',
        countryCode: 'UZ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'PAKISTAN',
        countryCode: 'PK',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'PANAMA',
        countryCode: 'PA',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Papouasie Nouvelle Guinée',
        countryCode: 'PG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'PARAGUAY',
        countryCode: 'PY',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'PAYS-BAS',
        countryCode: 'NL',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'Pérou ',
        countryCode: 'PE',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'PHILIPPINES',
        countryCode: 'PH',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'PITCAIRN',
        countryCode: 'PN',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'POLOGNE',
        countryCode: 'PL',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'PORTO RICO',
        countryCode: 'PR',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'PORTUGAL',
        countryCode: 'PT',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'QATAR',
        countryCode: 'QA',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'République Arabe Syrienne ',
        countryCode: 'SY',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'République Centrafricaine',
        countryCode: 'CF',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'République Démocratique du Congo ',
        countryCode: 'CD',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'République Dominicaine ',
        countryCode: 'DO',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'REPUBLIQUE TCHEQUE',
        countryCode: 'CZ',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'ROUMANIE',
        countryCode: 'RO',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'ROYAUME-UNI',
        countryCode: 'GB',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'RUSSIE',
        countryCode: 'RU',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'RWANDA',
        countryCode: 'RW',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'SAHARA OCCIDENTAL',
        countryCode: 'EH',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Saint Barthélémy ',
        countryCode: 'G2',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'SAINT MARTIN (Partie néerlandaise)',
        countryCode: 'MF',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'SAINT-CHRISTOPHE-ET-NIEVES, SAINT-KITTS-ET-NEVIS',
        countryCode: 'KN',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Sainte-Hélène',
        countryCode: 'SH',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'SAINT-MARIN',
        countryCode: 'SM',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'VATICAN',
        countryCode: 'VA',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'Saint Vincent et les Grenadines',
        countryCode: 'VC',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'SALVADOR',
        countryCode: 'SV',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'SAMOA',
        countryCode: 'WS',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Samoa Américaines',
        countryCode: 'AS',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Sao Tome et Principe',
        countryCode: 'ST',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Sénégal ',
        countryCode: 'SN',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'SERBIE',
        countryCode: 'RS',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'SEYCHELLES',
        countryCode: 'SC',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Sierra Léone',
        countryCode: 'SL',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'SINGAPOUR',
        countryCode: 'SG',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'SLOVAQUIE',
        countryCode: 'SK',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'SLOVENIE',
        countryCode: 'SI',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'SOUDAN',
        countryCode: 'SD',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Soudan du Sud ',
        countryCode: 'SS',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'SRI LANKA',
        countryCode: 'LK',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Suède ',
        countryCode: 'SE',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'SUISSE',
        countryCode: 'CH',
        deliveryTime: 4,
        shippingFee: 5.99,
    },
    {
        countryName: 'SURINAME',
        countryCode: 'SR',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Svalbard et ile Jan Mayen ',
        countryCode: 'SJ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'SWAZILAND',
        countryCode: 'SZ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'TADJIKISTAN',
        countryCode: 'TJ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'TAIWAN',
        countryCode: 'TW',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'TANZANIE',
        countryCode: 'TZ',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'TCHAD',
        countryCode: 'TD',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'THAILANDE',
        countryCode: 'TH',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'TIMOR ORIENTAL',
        countryCode: 'TL',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'TOGO',
        countryCode: 'TG',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'TOKELAU',
        countryCode: 'TK',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'TONGA',
        countryCode: 'TO',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Trinité et Tobago ',
        countryCode: 'TT',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Tristan da Cuhna ',
        countryCode: 'T2',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'TUNISIE',
        countryCode: 'TN',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'Turkménistan ',
        countryCode: 'TM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'TURQUIE',
        countryCode: 'TR',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'TUVALU',
        countryCode: 'TV',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'UKRAINE',
        countryCode: 'UA',
        deliveryTime: 4,
        shippingFee: 7.99,
    },
    {
        countryName: 'URUGUAY',
        countryCode: 'UY',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'VANUATU',
        countryCode: 'VU',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'VENEZUELA',
        countryCode: 'VE',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'VIET NAM',
        countryCode: 'VN',
        deliveryTime: 4,
        shippingFee: 15.99,
    },
    {
        countryName: 'YEMEN',
        countryCode: 'YE',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'ZAMBIE',
        countryCode: 'ZM',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'Zimbabwe ',
        countryCode: 'ZW',
        deliveryTime: 4,
        shippingFee: 21.99,
    },
    {
        countryName: 'GUADELOUPE',
        countryCode: 'GP',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'MARTINIQUE',
        countryCode: 'MQ',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'REUNION',
        countryCode: 'RE',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'GUYANE',
        countryCode: 'GF',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'MAYOTTE',
        countryCode: 'YT',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'SAINT PIERRE ET MIQUELON',
        countryCode: 'PM',
        deliveryTime: 4,
        shippingFee: 1.99,
    },
    {
        countryName: 'NOUVELLE CALEDONIE',
        countryCode: 'NC',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'POLYNESIE FRANCAISE',
        countryCode: 'PF',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'WALLIS ET FUTUNA',
        countryCode: 'WF',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
    {
        countryName: 'TERRES AUSTRALES ET ANTARCTIQUES FRANCAISES',
        countryCode: 'TAAF',
        deliveryTime: 4,
        shippingFee: 2.99,
    },
];
